'use client';

import ReactPlayer from 'react-player';
import { useEffect } from 'react';
import useAudioPlayer from '@/context/audioPlayer/useAudioPlayer';
import useAudio from '@/services/useAudio';
import { useIsMounted } from 'usehooks-ts';

function ReactAudioPlayer({ id }) {
    const isMounted = useIsMounted();
    const { logListenedTimeMutate } = useAudio({ id, willUseLog: true });
    const {
        isPlaying,
        setIsPlaying,
        streamLink,
        audioRef,
        runScripts,
        initialize,
        waiting,
        waitingEnd,
        updateProgress,
        onEnded,
        setCanPlay,
        isMuted
    } = useAudioPlayer({ logListenedTime: logListenedTimeMutate });

    function handlePlayingGlobalMedia(event) {
        const newlyPlayedMediaId = event.detail?.id;
        if (newlyPlayedMediaId !== id) {
            setIsPlaying(null);
        }
    }

    useEffect(() => {
        window.addEventListener('somethingPlayed', handlePlayingGlobalMedia);

        return () => {
            window.removeEventListener('somethingPlayed', handlePlayingGlobalMedia);
        };
    }, [id]);

    useEffect(() => {
        if (isPlaying) {
            const event = new CustomEvent('somethingPlayed', { detail: { id } });
            window.dispatchEvent(event);
        }
    }, [isPlaying]);

    if (!isMounted()) return <div></div>;
    return (
        <ReactPlayer
            onReady={runScripts}
            playing={!!isPlaying}
            url={streamLink}
            ref={audioRef}
            playsinline
            volume={1}
            width="100%"
            height="100%"
            onDuration={initialize}
            onEnded={onEnded}
            muted={isMuted}
            config={{
                file: {
                    attributes: {
                        onWaiting: waiting,
                        onCanPlayThrough: () => {
                            setCanPlay(true);
                            waitingEnd();
                        },
                        onTimeUpdate: updateProgress
                    }
                }
            }}
        />
    );
}

export default ReactAudioPlayer;
